'use strict';

exports.__esModule = true;
exports.default = applyContainerQuery;

var _react = require('react');

var _reactDom = require('react-dom');

var _createContainerQueryMixin = require('./createContainerQueryMixin');

var _createContainerQueryMixin2 = _interopRequireDefault(_createContainerQueryMixin);

var _DataStructure = require('./DataStructure');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Apply container query using higher order component style
 *
 * Refer to:
 * https://gist.github.com/sebmarkbage/ef0bf1f338a7182b6775
 *
 * @param {Component} Container - A react component
 * @param {Object} query - Container query definitions
 * @param {Object} [opts] - Additional options passed to `createContainerQueryMixin`
 * @param {string} [opts.propName='containerQuery'] - the property name to pass to applied container component
 *
 * @return {Component} A container query element
 */
function applyContainerQuery(Container, query) {
  var _ref = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];

  var _ref$propName = _ref.propName;
  var propName = _ref$propName === undefined ? 'containerQuery' : _ref$propName;
  var setAttribute = _ref.setAttribute;

  return (0, _react.createClass)({

    displayName: 'ContainerQuery',
    mixins: [(0, _createContainerQueryMixin2.default)(query, { setAttribute: setAttribute })],

    getInitialState: function getInitialState() {
      return { stateMap: null };
    },
    defineContainerComponent: function defineContainerComponent(ref) {
      this.defineContainer((0, _reactDom.findDOMNode)(ref));
    },
    containerQueryDidUpdate: function containerQueryDidUpdate(stateMap) {
      this.setState({ stateMap: stateMap });
    },
    render: function render() {
      var props = (0, _DataStructure.shallowCopyObj)(this.props);

      props.ref = this.defineContainerComponent;
      props[propName] = this.state.stateMap;

      return (0, _react.createElement)(Container, props);
    }
  });
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-container-query/lib/applyContainerQuery.js
 ** module id = 113
 ** module chunks = 0
 **/